import type {
  IShipmentRepository,
  ShipmentListQuery,
} from '@domain/data-contracts/shipment-repository.interface';
import type { Shipment } from '@domain/models/shipment.interface';
import type { PagedResult } from '@domain/models/paging.interface';

export class ShipmentsService {
  public constructor(private readonly repo: IShipmentRepository) {}

  public list(query: ShipmentListQuery): Promise<PagedResult<Shipment>> {
    return this.repo.list(query);
  }
}
